/**
 * MessagesHeaderButton — Core Frontend wrapper (Story 2.3.6.5 → 2.3.6.13 DRY)
 *
 * Thin wrapper around shared-ui-lib MessagesHeaderButton.
 * Provides app-specific data: unread count + i18n label.
 */

import { MessagesHeaderButton as SharedMessagesHeaderButton } from '@teletienda/shared-ui-lib';
import { useTranslation } from 'react-i18next';
import { useUnreadTotal } from '@/hooks/useConversations';

export function MessagesHeaderButton() {
  const { t } = useTranslation('common');
  const { data: totalUnread = 0 } = useUnreadTotal();

  return (
    <SharedMessagesHeaderButton
      unreadCount={totalUnread}
      to="/messages"
      label={t('messages.title')}
    />
  );
}
